<template>
  <v-layout align-content-center justify-center>

      <v-card width="100%"
      flat
       :class="{
        'pa-4 mt-4': $vuetify.breakpoint.smAndUp,
        'pa-4 mt-4 mx-4': $vuetify.breakpoint.xs,
      }">
       <v-card-text class="text-center">
          <v-icon color="primary" class="ma-2 vicon"
            >icons8-laptop-alert</v-icon
          >
          <h2 class="font-weight-bold primary--text my-5">404 - Page Not Found!</h2>
          <span class="subtitle-1 my-5"
            >The page you requested could not be found.Use the button below to
            return home.</span
          >
          <v-divider></v-divider>
          <br />
          <v-hover v-slot:default="{ hover }">
            <v-btn
              class="caption font-weight-light py-2"
              color="primary"
              :elevation="hover ? 12 : 2"
              rounded
              @click="goToLink"
              ><span class="seco text-uppercase">Back to home</span></v-btn
            ></v-hover
          >
       </v-card-text>
      </v-card>
 
  </v-layout>
</template>

<script>
export default {
  name: "Eror404",
  methods: {
    goToLink: function() {
      this.$router.push("/").catch((err) => {});
    },
  },
};
</script>

<style>
.vicon {
  font-size: 150px !important;
}
</style>
